<template>
  <v-app-bar
    app>
    <!-- <v-app-bar-nav-icon @click.stop="onClickBtn"/> -->
    <v-toolbar-title>
      <v-btn
        class="default v-btn--simple"
        dark
        icon
        @click.stop="onClickBtn"
      >
        <v-icon>mdi-view-list</v-icon>
      </v-btn>
      {{ $route.name }}
    </v-toolbar-title>

  
    <v-spacer />
    <v-toolbar-items>
      <v-flex
        align-center
        layout
        py-2>

        <v-btn dark v-if="isEmulation && !responsive" color="red" @click="stopEmulation">ATTENTION! You are in user emulation mode. Click to CANCEL</v-btn>
        <v-btn dark v-if="isEmulation && responsive" color="red" @click="stopEmulation">Cancel emulation mode</v-btn>

        <v-menu
            bottom
            left
            content-class="dropdown-menu"
            offset-y
            transition="slide-y-transition"
          >

          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on"  class="toolbar-items">
            <span color="success" v-if="!responsive">{{username}}</span> &nbsp; <v-icon color="tertiary">mdi-account</v-icon>
            </v-btn>
          </template>

          <v-list dense>
            <v-subheader v-if="responsive">{{username}}</v-subheader>
            <v-list-item @click='changePass'>Change password</v-list-item>
            <v-list-item to="/logout">
              Logout
            </v-list-item>
          </v-list>

        </v-menu>

      </v-flex>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { isEmulation, stopEmulation } from '@/utils/auth'

export default {
  data: () => ({
    title: null,
    responsive: false,
    responsiveInput: false,
    on: null,
  }),
  computed: {
    ...mapState(['user']),
    username() {

      return `${this.user.name}  ${this.user.surname} (${this.user.role})`

    },
    isEmulation() {
      return isEmulation()
    }
  },
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onClickBtn () {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    onClick () {
      //
    },
    changePass() {
      this.$store.dispatch("app/openChangePassword", {
        title: "Change password!"
      });
    },
    stopEmulation() {
      this.$store.dispatch("app/startLoading")
      stopEmulation();
      location.reload()
      // this.$router.replace({ name: 'Dashboard', force: true });
    },
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
        this.responsiveInput = false
      } else {
        this.responsive = false
        this.responsiveInput = true
      }
    }
  }
}
</script>

<style>
/* #core-toolbar a {
  text-decoration: none;
}
.v-toolbar {
  margin-bottom:0px !important;
} */
</style>
